<template>
<div style="width:100%;">
 
  <!-- bulma menuing -->
  <nav class="navbar is-fixed-top" role="navigation" aria-label="main navigation" >
    <div class="navbar-brand">
      <div style="height:40px" >
        <router-link to="/" class="navbar-item"><img src="../../assets/images/logo-light.png" id="logo" height="27px" width="77px" ></router-link>
      </div>

      <a id="burger" v-on:click="toggleBurger()" role="button" class="navbar-burger burger" aria-label="menu" aria-expanded="false" data-target="navbarMainMenu">
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
      </a>
    </div>

    <div id="navbarMainMenu" class="navbar-menu">   
      <!-- START -->  
      <div class="navbar-start">        
        
        

        <!-- SERVICES -->
        <div class="navbar-item has-dropdown is-hoverable ">
          <router-link to="/services/health-accountability" class="navbar-link navbar-arrow"><span v-on:click="toggleMenus">Services</span></router-link>
                  
          <div class="navbar-dropdown">
            
            <router-link to="/services/health-monitoring" class="navbar-item" ><span v-on:click="toggleMenus">Fitness For Duty Health Monitoring</span></router-link>
            <router-link to="/services/medical-management-platform" class="navbar-item" ><span v-on:click="toggleMenus">FMCSA Medical Management Platform</span></router-link>
            <router-link to="/services/health-accountability" class="navbar-item" ><span v-on:click="toggleMenus">Longevity Medical Wellbeing</span></router-link>
            <router-link to="/services/department-of-transportation" class="navbar-item" ><span v-on:click="toggleMenus">FMCSA Commercial Driver Medical Director Oversight</span></router-link>
            <router-link to="/services/united-states-coast-guard" class="navbar-item" ><span v-on:click="toggleMenus">USCG Medical Director Oversight</span></router-link>
            <router-link to="/services/covid19-health-management" class="navbar-item" ><span v-on:click="toggleMenus">Covid-19 Workplace Health</span></router-link>

            <!-- MEDICAL DIRECTOR SERVICES -->
            <!--<div class="nested dropdown r">
              <a class="navbar-item" style="text-align:left" ><i class="fas fa-folder-open" style="color:#473F44;margin-right:5px;"></i>Meidcal Director Services</a>
              <div class="dropdown-menu" role="menu">
                <div class="dropdown-content" >
                  <router-link to="/services/department-of-transportation" class="navbar-item" ><span v-on:click="toggleMenus">DOT/CDL Certification</span></router-link>
                  <router-link to="/services/united-states-coast-guard" class="navbar-item" ><span v-on:click="toggleMenus">USCG Medical Certification</span></router-link>
                  <router-link to="/services/health-accountability" class="navbar-item" ><span v-on:click="toggleMenus">360 Health Accountability</span></router-link>
                  </div>
              </div>
            </div>
            <br>-->
            
            <!-- CORPORATE HEALTH SERVICES -->
            <div class="nested dropdown r">
              <a class="navbar-item" style="text-align:left" ><i class="fas fa-folder-open" style="color:#473F44;margin-right:5px;"></i>Corporate Clinic Services</a>
              <div class="dropdown-menu" role="menu">
                <div class="dropdown-content" >
                  <router-link to="/services/medical-director-service" class="navbar-item" ><span v-on:click="toggleMenus">Customer Medical Director Support</span></router-link>
                  <router-link to="/services/covid19-point-of-care" class="navbar-item" ><span v-on:click="toggleMenus">Covid-19 Point of Care Testing</span></router-link>
                  <router-link to="/services/medical-surveillance-osha" class="dropdown-item" ><span v-on:click="toggleMenus">Medical Surveillance (OSHA)</span></router-link>
                  <router-link to="/services/faa-medical-certification" class="dropdown-item" ><span v-on:click="toggleMenus">FAA Medical Certification</span></router-link>
                  <router-link to="/services/executive-healthcare" class="dropdown-item" ><span v-on:click="toggleMenus">Executive Healthcare</span></router-link>
                  <router-link to="/services/pre-placement-exams" class="dropdown-item" ><span v-on:click="toggleMenus">Pre Placement Exams</span></router-link>
                  <router-link to="/services/fitness-for-duty-exams" class="dropdown-item" ><span v-on:click="toggleMenus">Fitness For Duty Exams</span></router-link>
                  <router-link to="/services/drug-and-alcohol-testing" class="dropdown-item" ><span v-on:click="toggleMenus">Drug & Alcohol Testing</span></router-link>
                  <router-link to="/services/immigration-medical-exams" class="dropdown-item" ><span v-on:click="toggleMenus">Immigration Medical Exams</span></router-link>
                  <router-link to="/services/independent-medical-exams-ime" class="dropdown-item" ><span v-on:click="toggleMenus">Independent Medical Exams (IME)</span></router-link>
                  <router-link to="/services/laboratory-service" class="dropdown-item" ><span v-on:click="toggleMenus">Laboratory Services</span></router-link>
                </div>
              </div>
            </div>
            <br>
            
            
            
            
            <!-- COVID 19 HEALTH MAMAGMENT -->
            <!--<div class="nested dropdown r">
              <a class="navbar-item" style="text-align:left" ><i class="fas fa-folder-open" style="color:#473F44;margin-right:5px;"></i>Covid-19 Health Management</a>
              <div class="dropdown-menu" role="menu">
                <div class="dropdown-content" >
                  <router-link to="/services/covid19-health-management" class="navbar-item" ><span v-on:click="toggleMenus">Product Details</span></router-link>
                  <a href="https://ehealthengagement.com/sales/products/covid-19_health_management_product_sheet.pdf" target="_blank" class="navbar-item" ><span v-on:click="toggleMenus">Product Sheet</span></a>
                </div>
              </div>
            </div> 
            <br>-->
          </div>
        </div>
        
        <!-- COMPANY -->
        <div class="navbar-item has-dropdown is-hoverable">
          <!--is-arrowless from navbar-link class-->
          <router-link to="/company/what-we-do" class="navbar-link navbar-arrow"><span v-on:click="toggleMenus">Company</span></router-link>
          <div class="navbar-dropdown">
            <router-link to="/company/what-we-do" class="navbar-item" ><span v-on:click="toggleMenus">What We Do</span></router-link>
            <router-link to="/company/our-story" class="navbar-item" ><span v-on:click="toggleMenus">Our Story</span></router-link>
            <router-link to="/company/executive-management-team" class="navbar-item"><span v-on:click="toggleMenus">Executive Management</span></router-link>
            <router-link to="/company/our-team" class="navbar-item"><span v-on:click="toggleMenus">Our Experienced Team</span></router-link>
            <router-link to="/company/mission-statement" class="navbar-item"><span v-on:click="toggleMenus">Mission Statement</span></router-link>
            <router-link to="/company/commitment" class="navbar-item"><span v-on:click="toggleMenus">Commitment</span></router-link>
            <router-link to="/company/solution" class="navbar-item"><span v-on:click="toggleMenus">Solution</span></router-link>
          </div>
        </div>

        <!-- INFORMATION -->
        <div class="navbar-item has-dropdown is-hoverable">
          <router-link to="/news" class="navbar-link navbar-arrow"><span v-on:click="toggleMenus">Information</span></router-link>
          <div class="navbar-dropdown">
            <router-link to="/news" class="navbar-item"><span v-on:click="toggleMenus">Newsroom</span></router-link>
            <router-link to="/careers/intro" class="navbar-item" ><span v-on:click="toggleMenus">Careers</span></router-link>
            <router-link to="/information/links" class="navbar-item" ><span v-on:click="toggleMenus">Useful Links</span></router-link>
          </div>
        </div>

        <!-- CONTACT -->
        <div class="navbar-item" >
          <router-link to="/contact" class="navbar-item"><span v-on:click="toggleMenus">Contact</span></router-link>
        </div> 
      </div>

      <!-- NAVBAR END -->
      <div class="navbar-end">  
        <div id="menuSignon" class="navbar-item">
          <a v-on:click="onEngageForMembersClick" class="navbar-item"><span style="white-space:pre">Member Sign-In </span><font-awesome-icon :icon="['fas', 'sign-in-alt']" style="color:silver"/></a>
        </div>
        

        <div class="navbar-item">
          <a href="https://www.linkedin.com/company/ehealthengagement/about/?viewAsMember=true"><font-awesome-icon :icon="['fab', 'linkedin']"  style="color:silver"/></a>
        </div> 
        <div class="navbar-item">
          <a href="https://www.facebook.com/EHealthEngagement/"><font-awesome-icon :icon="['fab', 'facebook']" style="color:silver"/></a>
        </div>
        <div style="width:40px"/>
      </div>
    </div>
  </nav>
<div></div>
</div>

</template>

<script>
//import { API } from '../../api/member-api'
//const { API } = require( '../../api/member-api' + '?v=' + process.env.VUE_APP_VERSION )
//import messageBox from '../../views/member-app/common/message-box'

export  default {
  name: 'HeaderView',
  methods:
  {
    onEngageForMembersClick()
    {
      window.location.href = window.Vue.prototype.$config.engageForMembersUrl ;
      
      /* switch(API.getPlatform())
      {
        case "dev":
          {
            window.location.href = "http://localhost/EngageForMembers/";
            return;
          }
        case "test":
          {
            window.location.href = "http://34.196.154.96:82/EngageForMembers/";
            return;
          }
        case "live":
          {
            window.location.href = "https://www.ehealthengagement.com/EngageForMembers/";
            return;
          }

      } */
    },
    /* onLogoff()
    {

      API.logoff(window.sessionKey);
      window.sessionKey = '';

      let menuLogoff = document.getElementById('menuLogoff');
      let menuSignon = document.getElementById('menuSignon');
      menuLogoff.classList.add('is-hidden');
      menuSignon.classList.remove('is-hidden'); 
      
      this.$generalMessage(messageBox, this.$t("header.loggedOut"),  this.onLogoffClose);
    },
    onLogoffClose()
    {
      this.$router.push( { path: "/members/signon"} );
    }, */
    toggleBurger()
    {
      let burgerIcon = document.getElementById('burger');
      let dropMenu = document.getElementById('navbarMainMenu');
      burgerIcon.classList.toggle('is-active');
      dropMenu.classList.toggle('is-active');      
    },

    toggleMenus()
    {
      //alert('hit');
      //event.target.classList.toggle('is-active')
      let burgerIcon = document.getElementById('burger');
      let dropMenu = document.getElementById('navbarMainMenu');

      burgerIcon.classList.toggle('is-active');
      dropMenu.classList.toggle('is-active');    
    }
  },
  mounted(){
    /* let menu = document.getElementById('menuLogoff');
    menu.classList.toggle('is-hidden'); */
    /* var scale = 'scale(1)';
      document.body.style.webkitTransform =  scale;    // Chrome, Opera, Safari
      document.body.style.msTransform =   scale;       // IE 9
      document.body.style.transform = scale;     // General */

    let burger = document.getElementById('burger');
    let menu = document.getElementById('navbarMainMenu');

    const links = menu.querySelectorAll(".navbar-item");
    links.forEach(link => {
        link.addEventListener("click", function () {
            burger.classList.remove("is-active");
            menu.classList.remove("is-active");
        });
    });
  }
}

</script>

<style lang="scss" scoped>

// DISABLE WIDESCREEN BREAKPOINT
$widescreen-enabled: false;

// DISABLE FULLHD BREAKPOINT
$fullhd-enabled: false;

//////////////////////////////////////////
// MOBILE
@media only screen and 
(min-width : 320px) and (max-width : 1023px)
{  

  // LOGO
  #logo
  {
    background-color:#473F44;
    height:40px;
  }

  // BURGER
  .burger
  {
    height:40px;
    max-height:40px;
    min-height:40px;
    color:silver;
  }

  // NAVBAR
  .navbar
  {
    font-family: Lato;
    font-size: 1em;
    font-weight:300;
    min-height:40px;
    max-height: 40px;
    height:40px;
    margin-bottom: 0px;
    padding-bottom: 0px; 
    background-color:#473F44;
  }

  // BRAND
  .navbar-brand
  { 
    height:400px;
    min-height:40px;
    max-height: 40px;
    margin-bottom: 0px;
    padding-bottom: 0px;
    background-color:#473F44;
  }

  // MENU POSITION
  nav.navbar.is-fixed-top
  {
    margin:0px;
    padding:0px;
    height:40px;
  }

  // MAIN MENU BAR BACK COLOR 
  .navbar-menu
  {
    height:500px;
    background-color:#473F44;
  }

  // MAIN MENU TEXT COLOR 
  .navbar-link
  {
    font-family: Lato;
    font-weight: 300;
    color:white;
  }

  // MAIN MENU MOUSE OVER TEXT COLOR 
  .navbar-link:hover
  {
    color: slategray;
  }

  // MAIN MENU MOUSE OVER TEXT COLOR WHEN THERE IS A DROPDOWN
  .navbar-link:backdrop
  {
    color: black;
  }
  .navbar-link{
    color:white;
    background-color:#473F44 !important;
  }
  .navbar-link:hover{
    color:white;
    background-color:#473F44 !important;
  }
.navbar-arrow:after {
  border-color:#E3E4E6//cadetblue;
}

  // SUB MENU BACKGROUND 
  .navbar-dropdown
  {
    font-family: Lato;
    min-width: 130px;
    background-color: rgb(70,130,180);
    color:#F2F3F4;

  }

  // SUB MENU TEXT COLOR
  .navbar-item
  {
    color:#F2F3F4;
    
  }

  // SINGLE SUBMENU MOUSE OVER TEXT
  .navbar-item:hover{
    color:gray;
    background-color: white;
  }  

  // SINGLE SUBMENU MOUSE OVER TEXT
  .navbar-item:hover{
    color:white;
    background-color: gray;
  }  

  .navbar-dropdown:hover {
    color:white;
    //background-color:gray;
  }
  
  // OVERWRITE DEFAULT TO CLOSE MENUS AFTER CLICK
  .navbar-item.is-hoverable:hover .navbar-dropdown 
  {
      display: block !important;
  }
  .navbar-item.is-hoverable:focus-within .navbar-dropdown 
  {
      display: none;
  } 


  // NESTED DROPDOWN MENUS
  .nested.dropdown:hover > .dropdown-menu {
    display: block;
  }
  .nested.dropdown.r .dropdown-menu {
    top: 30px; // MOVE MENU DOWN
    padding-right:0px;
    margin-right:0px;
    width:235px; // SUBMENU WIDTH
    white-space: nowrap;
    margin-left: 10%;
  }
  .nested.dropdown .dropdown-menu {
    top: -12px;
    padding-right:0px;
    margin-right:0px;
    width:100%;
    white-space: nowrap;
    //margin-left: -100%;
  }
  .nested.dropdown .dropdown-trigger button::after {

  }
  .nested.dropdown .dropdown-trigger button {
    padding: 0px 0px;
    border: 0px;
  }
  .dropdown-content{
    min-width:75px;
    background-color:rgb(70,130,180);
    border:1px solid gray;
    color:white;

  }
  .dropdown-item{
    padding-right:15px !important;
    padding-left:15px;
    color:white;
  }

}

//////////////////////////////////////////
// DESKTOP
@media screen and (min-width:1024px) 
{
  // LOGO
  #logo
  {
    background-color:#473F44;
    height:40px;
  }

  .burger
  {
    height:40px;
    max-height:40px;
    min-height:40px;
    color:silver;
  }
  // NAVBAR
  .navbar
  {    
    font-family: Lato;
    font-size: 1em;
    font-weight:300;
    min-height:40px;
    max-height: 40px;
    height:40px;
    margin-bottom: 0px;
    padding-bottom: 0px;    
  }

  // BRAND
  .navbar-brand
  {
    height:40px;
    min-height:40px;
    max-height: 40px;
    margin-bottom: 0px;
    padding-bottom: 0px;
    background-color:#473F44;
  }

  // MENU POSITON
  nav.navbar.is-fixed-top
  {
    margin:0px;
    padding:0px;
    height:40px;
  }

  // MAIN MENU BAR BACK COLOR 
  .navbar-menu
  { 
    height: 40px;
    font-weight: 300;
    background-color:#473F44;
  }
  
  // MAIN MENU TEXT COLOR 
  .navbar-link
  {
    font-family: Lato;
    font-weight: 300;
    color: white ;
  }

  // MAIN MENU MOUSE OVER TEXT COLOR WHEN THERE IS A DROPDOWN
  .navbar-link:backdrop
  {
    color: black;
  }
  .navbar-link{
    color:white;
    background-color:#473F44 !important;
  }
  .navbar-link:hover{
    color:white;
    background-color:#473F44 !important;
  }
  .navbar-arrow:after {
    border-color:#E3E4E6//cadetblue;
  }

  // SUB MENU BACKGROUND 
  .navbar-dropdown
  {
    font-family: Lato;
    font-weight: 300;
    min-width: 130px;
    background-color: rgb(70,130,180);
    color:gray;
    
  }

  // SUB MENU TEXT COLOR
  .navbar-item
  {
    color:white;
    text-align: left;
  }

  // SINGLE SUBMENU MOUSE OVER TEXT
  .navbar-item:hover{
    color:white;
    background-color: gray;
  }  
  .navbar-dropdown:hover {
    color:white;
    //background-color:gray;
    
  }
  
  // OVERWRITE DEFAULT TO CLOSE MENUS AFTER CLICK
  .navbar-item.is-hoverable:hover .navbar-dropdown 
  {
      display: block !important;
  }
  .navbar-item.is-hoverable:focus-within .navbar-dropdown 
  {
      display: none;
  } 

  // NESTED DROPDOWN MENUS
  .nested.dropdown:hover > .dropdown-menu {
    display: block;
  }
  .nested.dropdown.r .dropdown-menu {
    top: -12px;
    padding-right:0px;
    margin-right:0px;
    width:235px; // SUBMENU WIDTH
    white-space: nowrap;
    margin-left: 100%;
  }
  .nested.dropdown .dropdown-menu {
    top: -12px;
    padding-right:0px;
    margin-right:0px;
    width:100%;
    white-space: nowrap;
    margin-left: -100%;
  }
  
   .nested.dropdown .dropdown-trigger button::after {

  }
  .nested.dropdown .dropdown-trigger button {
    padding: 0px 0px;
    border: 0px;
  }
  .dropdown-content{
    min-width:75px;
    background-color:rgb(70,130,180);
    color:white;

  }
  .dropdown-item{
    padding-right:15px !important;
    padding-left:15px;
    color:white;
  }

  ////////////////////////
 
}
   
  
</style>